// Native details navigation works without JS; enhancement restores focus on Escape.
(() => {
  if (window.phreshNavigationBound) return;
  window.phreshNavigationBound = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ph-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ph-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
      if (event.target.closest('.ph-menu a')) {
        menu.open = false;
        const hash = event.target.closest('a').hash;
        const target = hash ? document.getElementById(hash.slice(1)) : null;
        if (target) {
          target.tabIndex = -1;
          target.focus({ preventScroll: true });
        }
      }
    });
  });
})();

// Delegated listener survives Shopify section re-rendering without duplicate bindings.
(() => {
  if (window.phreshPackBound) return;
  window.phreshPackBound = true;
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const shop = input.closest('[data-ph-pack-shop]');
    if (!shop) return;
    shop.querySelectorAll('[data-ph-media]').forEach(media => {
      media.hidden = media.dataset.phMedia !== input.value;
    });
    shop.querySelector('[data-ph-price]').textContent = input.dataset.price;
    shop.querySelector('[data-ph-caption]').textContent = input.dataset.count + ' · ' + shop.querySelector('.ph-product-size').textContent;
    shop.querySelector('[data-ph-selection-status]').textContent = input.dataset.count + ' — ' + input.dataset.price;
  });
})();
